import { useEffect, useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listDisseminationLessonService } from "../services/listDisseminationLesson.service";

const LIMIT = 20;

export const useDisseminationLessonQuery = (filters) => {
  const fetchData = useFetch();
  const [disseminationLessons, setDisseminationLessons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const fetchDisseminationLessons = async () => {
      try {
        setLoading(true);
        const response = await listDisseminationLessonService(fetchData)({
          limit: LIMIT,
          offset: (currentPage - 1) * LIMIT,
          ...filters,
        });

        setDisseminationLessons(response.data);
        setTotalItems(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchDisseminationLessons, 500);
    debounced();
    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, currentPage, filters]);

  return {
    disseminationLessons,
    loading,
    currentPage,
    totalPages,
    totalItems,
    refresh: () => setRefresh((prev) => !prev),
    onChangePage: (page) => setCurrentPage(page),
  };
};
